'use client';

import { useLanguage } from '@/lib/i18n/LanguageContext';

interface OfflineReserveModalProps {
  amount: number;
  currency: string;
  instructions: string;
  submitting: boolean;
  onConfirm: () => void;
  onClose: () => void;
}

export default function OfflineReserveModal({
  amount, currency, instructions, submitting, onConfirm, onClose,
}: OfflineReserveModalProps) {
  const { t } = useLanguage();
  return (
    <div
      className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/50 p-4"
      onClick={(e) => { if (e.target === e.currentTarget && !submitting) onClose(); }}
    >
      <div className="relative bg-white rounded-2xl shadow-2xl w-full max-w-[480px] p-6">
        <h3 className="text-lg font-semibold text-gray-900 mb-2">
          {t('offlinePayment.reserveTitle') || 'Зарезервувати місце'}
        </h3>
        <p className="text-sm text-gray-600 mb-4">
          {t('offlinePayment.reserveSubtitle') || 'Оплата приймається офлайн. Підтвердіть бронювання, і ви отримаєте інструкції для оплати.'}
        </p>
        <div className="text-base mb-4">
          {t('offlinePayment.amountDue') || 'До сплати'}: <strong>{amount} {currency}</strong>
        </div>
        {instructions?.trim() && (
          <div className="bg-gray-50 rounded-lg p-3 text-sm text-gray-700 whitespace-pre-line mb-4">
            {instructions}
          </div>
        )}
        <div className="flex gap-3 justify-end">
          <button
            onClick={onClose}
            disabled={submitting}
            className="px-4 py-2 rounded-lg text-sm text-gray-600 hover:bg-gray-100 disabled:opacity-50"
          >
            {t('common.cancel') || 'Скасувати'}
          </button>
          <button
            onClick={onConfirm}
            disabled={submitting}
            className="px-4 py-2 rounded-lg text-sm font-medium bg-blue-600 text-white hover:bg-blue-700 disabled:opacity-50"
          >
            {submitting ? (t('common.processing') || 'Обробка…') : (t('offlinePayment.confirmReservation') || 'Підтвердити бронювання')}
          </button>
        </div>
      </div>
    </div>
  );
}
